import { useFeatureFlags } from '@/hooks';
import type { ExperimentationFeatureFlagsEntityTypeV1 } from '@montugroup/data-collection';
import { createFeatureFlagContext, featureFlagFilters } from '@montugroup/data-collection';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { useMemo } from 'react';
import { PMS_ANALYTICS_FLAGS } from '../constants';

/**
 * Returns LaunchDarkly feature flags formatted for analytics,
 * filtered by PMS_ANALYTICS_FLAGS.
 *
 * @returns Analytics-ready flags branch (`{ flags: [...] }`) for use in analytics context
 */
export const useAnalyticsFeatureFlags = (): ExperimentationFeatureFlagsEntityTypeV1 => {
  const { flags } = useFeatureFlags();
  const ldClient = useLDClient();

  const flagContext = useMemo(
    () =>
      createFeatureFlagContext({
        ldClient,
        flags,
        filter: featureFlagFilters.includeOnly(PMS_ANALYTICS_FLAGS),
      }),
    [flags, ldClient],
  );

  return flagContext[0]?.data ?? { flags: [] };
};
